module.exports = __webpack_public_path__ + "img/logo.d38861eb.png";